import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { AdminService } from "../../../app/service/admin.service";
import { courses } from "../../../config";

const EditFilterAccess = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<any>({
    course: "",
    btechCourse: "",
  });

  const location = useLocation();
  const { state } = location;

  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    if (state) {
      setFormData({
        course: state.course || "",
        btechCourse: state.btechCourse || "",
      });
    }
  }, [state]);

  const handleInput = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevState: any) => ({
      ...prevState,
      [name]: name === "courseName" ? value.split(",") : value,
    }));
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors: any = {};

    if (!formData.course) {
      newErrors.course = "Course is required";
    }

    if (!formData.btechCourse) {
      newErrors.btechCourse = "Btech Course is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRegister = (e: any) => {
    e.preventDefault();

    let payload = {
      course: formData.course,
      btechCourse: formData.btechCourse,
      filterAccessId: state._id,
    };

    if (validate()) {
      AdminService.updatefilterAccess(payload).then((res) => {
        if (res.status === "Fail") {
          toast.error(res.error);
        } else {
          toast.success(res.message);
          navigate("/admin/filterAccessList");
        }
      });
    }
  };

  const handleCancel = () => {
    navigate("/admin/filterAccessList");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <Header />
      </div>
      <div className="row">
        <div className="col-md-2 h-100 px-0">
          <Sidebar />
        </div>
        <div className="col-md-10 content-scroll content-bg px-3 py-3">
          <h4 style={{ textAlign: "left" }}>
            <b>Edit Filter Access</b>
          </h4>
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group mt-3">
                  <label className="register-font">Course *</label>
                  <select
                    className={`form-control mt-2 ${
                      errors.course ? "is-invalid" : ""
                    }`}
                    onChange={handleInput}
                    name="course"
                  >
                    <option>Select Courses</option>
                    {courses.map((ele: any, index) => {
                      return (
                        <option value={ele.name} key={index}>
                          {ele.name}
                        </option>
                      );
                    })}
                  </select>
                  {errors.course && (
                    <div className="invalid-feedback">{errors.course}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group mt-3">
                  <label className="register-font">B.tech Course *</label>
                  <input
                    type="text"
                    className={`form-control mt-2 ${
                      errors.btechCourse ? "is-invalid" : ""
                    }`}
                    placeholder="B.tech Course"
                    name="btechCourse"
                    value={formData.btechCourse}
                    onChange={handleInput}
                  />
                  {errors.btechCourse && (
                    <div className="invalid-feedback">{errors.btechCourse}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-3">
              <button
                type="submit"
                className="btn btn-primary me-2"
                onClick={handleRegister}
              >
                Update
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditFilterAccess;
